import url from '@/creditflowresearch/infrastructure/url';
import { ISingleStatWithData } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Stat';

const getStatMetaSchema = (pathname: string, stat: ISingleStatWithData) => {
  const { name, author, updatedAt: date, categories, description } = stat;

  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    url: url.getUrl(pathname),
    headline: name,
    description,
    keywords: [...categories, 'fixed income', 'ABS', 'market update'],
    author: {
      '@type': 'Organization',
      name: author,
    },
    datePublished: date,
    isAccessibleForFree: false,
    hasPart: {
      '@type': 'WebPageElement',
      isAccessibleForFree: false,
      cssSelector: '[data-test="statImagePreview"]',
    },
  };
};

export default getStatMetaSchema;
